(function(){
  /* Wear Healthy v2: make sure the muted loop videos play (iOS needs the muted property, not only the attribute). */
  function initVideos(scope){
    (scope||document).querySelectorAll('.jmh-wh video').forEach(function(v){
      v.muted=true;v.defaultMuted=true;v.loop=true;v.playsInline=true;v.setAttribute('playsinline','');v.setAttribute('muted','');v.removeAttribute('controls');
      function play(){var p=v.play();if(p&&p.catch)p.catch(function(){});}
      if('IntersectionObserver' in window){
        new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting)play();else v.pause();});},{rootMargin:'200px'}).observe(v);
      } else play();
    });
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',function(){initVideos()});else initVideos();
  document.addEventListener('shopify:section:load',function(e){initVideos(e.target)});
})();
